// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sh2x","label":"styles_label__1bQbb"};